var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StepForMobile',{attrs:{"currentStep":3,"screenType":_vm.screenType,"title":this.$t('Sending & Filtering')}}),(_vm.uploadStep === 3)?_c('UploadProgress'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }